import React, { useRef, useState } from 'react';
import api from '../services/api';

// Campo de upload de imagem reutilizável (LE-010Z — logo/capa do comércio;
// LE-023 — avatar de perfil). Faz o upload IMEDIATO ao escolher o arquivo
// (POST /api/upload/image, CSRF via interceptor) e devolve a URL via onUploaded;
// a persistência do vínculo (PATCH da entidade) fica a cargo da página.
export function ImageUploadField({
  label,
  hint,
  value,
  purpose,
  entityId,
  onUploaded,
  onClear,
  accent,
  round = false,
}) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = ''; // permite reenviar o mesmo arquivo
    if (!file) return;

    setUploading(true);
    setUploadError(null);
    try {
      const fd = new FormData();
      fd.append('image', file);
      fd.append('purpose', purpose);
      fd.append('entity_id', String(entityId));
      // axios detecta FormData e define o Content-Type com boundary automaticamente
      const { data } = await api.post('/upload/image', fd);
      onUploaded(data.url);
    } catch (err) {
      setUploadError(err.response?.data?.error?.message || 'Erro no upload. Tente novamente.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <label className="nc-hint" style={{ display: 'block', fontWeight: 600, marginBottom: 6 }}>
        {label}
      </label>
      <input
        ref={fileRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        onChange={handleFile}
        style={{ display: 'none' }}
        aria-label={`Escolher ${label}`}
      />
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div
          onClick={() => fileRef.current?.click()}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') fileRef.current?.click(); }}
          style={{
            width: 72, height: 72, borderRadius: round ? '50%' : 12, overflow: 'hidden', flexShrink: 0,
            background: value ? '#f3f4f6' : (accent || 'linear-gradient(135deg, #0d5c3b, #094a2f)'),
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer', border: '1px dashed ' + (value ? 'transparent' : 'rgba(255,255,255,0.5)'),
            transition: 'opacity 0.15s ease'
          }}
          onMouseEnter={e => { e.currentTarget.style.opacity = 0.85; }}
          onMouseLeave={e => { e.currentTarget.style.opacity = 1; }}
          aria-label={`Enviar ${label}`}
        >
          {value ? (
            <img src={value} alt={label} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : uploading ? (
            <span style={{ color: 'var(--nc-on-primary)', fontSize: 11, textAlign: 'center', padding: 4 }}>
              Enviando...
            </span>
          ) : (
            <span style={{ color: 'var(--nc-on-primary)', fontSize: 22 }}>📷</span>
          )}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={() => fileRef.current?.click()}
              disabled={uploading}
              style={{
                padding: '8px 14px', borderRadius: 8, border: '1px solid var(--nc-border)',
                background: 'var(--nc-surface)', color: 'var(--nc-primary)', fontSize: 12, fontWeight: 600, cursor: 'pointer'
              }}
            >
              {value ? 'Trocar' : 'Enviar imagem'}
            </button>
            {value && (
              <button
                type="button"
                onClick={onClear}
                disabled={uploading}
                style={{
                  padding: '8px 14px', borderRadius: 8, border: '1px solid var(--nc-danger-border)',
                  background: 'var(--nc-danger-soft)', color: 'var(--nc-danger-text)', fontSize: 12, fontWeight: 600, cursor: 'pointer'
                }}
              >
                Remover
              </button>
            )}
          </div>
          <div className="nc-caption" style={{ marginTop: 6 }}>{hint}</div>
          {uploadError && <div role="alert" style={{ fontSize: 12, color: 'var(--nc-danger-text)', marginTop: 6 }}>{uploadError}</div>}
        </div>
      </div>
    </div>
  );
}
